<template>
  <Form ref="form" @submit="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Editar Disposición</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row card-body">
        <!-- Información de solo lectura -->
        <div class="form-group col-sm-12">
          <label for="ProspectFullname">Prospecto:</label>
          <Field :value="prospectFullname" type="text" class="form-control col-sm-9" name="ProspectFullname" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="address">Domicilio:</label>
          <Field :value="prospectAddress" type="text" class="form-control col-sm-9" name="prospectusAddress" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="productTypeId">Tipo de Producto:</label>
          <Field :value="productTypeName" type="text" class="form-control col-sm-9" name="productTypeId" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="DisbursementDate">Fecha de Disposición:</label>
          <Field :value="dateDistribution" type="text" class="form-control col-sm-9" name="DisbursementDate" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="authorizedAmount">Monto autorizado:</label>
          <Field :value="creditAmount" type="text" class="form-control col-sm-9" name="authorizedAmount"
            disabled />
        </div>

        <!-- Datos bancarios -->
        <div class="col-sm-12">
          <label for="bank">Datos bancarios:</label>
        </div>
        <div class="form-group col-sm-6">
          <label for="accountHoldersName">Nombre de titular:</label>
          <Field :value="directDebitAccountHoldersName" type="text" class="form-control col-sm-9"
            name="accountHoldersName" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="bankAccount">Número de cuenta:</label>
          <Field :value="directDebitBankAccount" type="text" class="form-control col-sm-9" name="bankAccount"
            disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="clabe">CLABE Interbancaria:</label>
          <Field :value="directDebitClabe" type="text" class="form-control col-sm-9" name="clabe" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="bankName">Nombre del banco:</label>
          <Field :value="directDebitNameBank" type="text" class="form-control col-sm-9" name="bankName" disabled />
        </div>

        <!-- Archivo actual - SECCIÓN AGREGADA  -->
        <div class="form-group col-sm-12" v-if="currentFile">
          <label>Comprobante actual:</label>
          <div class="current-file">
            <a href="#" @click.prevent="downloadCurrentFile" class="btn btn-sm btn-info"
              :class="{ 'disabled': downloading }">
              <i class="fa" :class="downloading ? 'fa-spinner fa-spin' : 'fa-download'"></i>
              {{ downloading ? 'Descargando...' : currentFile.name }}
            </a>
            <span class="file-size">({{ formatFileSize(currentFile.size) }})</span>
          </div>
        </div>

        <!-- Nuevo archivo -->
        <div class="form-group col-sm-6">
          <label :for="'exampleInputFile'">Reemplazar comprobante:</label>
          <div class="input-group">
            <label>
              <input type="file" ref="fileInput" class="" :id="'exampleInputFile'"
                accept=".jpg, .jpeg, .png, .gif, .pdf" @change="handleFileChange($event)" />
              <span class="file-custom"></span>
            </label>
            <label class="custom-file-label" for="exampleInputFile">
              {{ selectedFile ? selectedFile.name : 'Seleccionar archivo' }}
            </label>
          </div>
          <small class="form-text text-muted">
            Formatos permitidos: JPG, PNG, GIF, PDF. Tamaño máximo: 5MB
          </small>
        </div>

        <!-- Validaciones -->
        <div class="form-group col-sm-12">
          <ul class="list-unstyled">
            <li>
              <label for="operationalValidation">Validación Operativa:</label>
              <i v-if="flowStatusAuthorizationOperative === 1" class="fa fa-check text-success"></i>
              <i v-else class="fa fa-times text-danger"></i>
            </li>
            <li>
              <label for="legalValidation">Validación Legal:</label>
              <i v-if="flowStatusAuthorizationLegal === 1" class="fa fa-check text-success"></i>
              <i v-else class="fa fa-times text-danger"></i>
            </li>
            <li>
              <label for="pldValidation">Validación PLD:</label>
              <i v-if="flowStatusAuthorizationAml === 1" class="fa fa-check text-success"></i>
              <i v-else class="fa fa-times text-danger"></i>
            </li>
          </ul>
        </div>

        <!-- Estatus (editable) -->
        <div class="form-group col-sm-12">
          <label for="statusId">Estatus:</label>
          <StatusSelect v-model="selectedStatusId" :name="'statusId'" :options="statusOptions" :isDisabled="isDisabled">
          </StatusSelect>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">
        {{ cancelButton }}
      </button>
      <PrimaryButton class="btn btn-primary" type="submit" :disabled="isDisabledCreate">
        {{ updateButton }}
      </PrimaryButton>
    </div>
  </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from "pinia";
import { useStatusStore } from '@/pinia/status.module';
import { useToast } from 'vue-toast-notification';
import { getLocaleMessage } from '@/services/MessagesService';
import { useCreditFacilities } from '@/pinia/creditFacilities.module';
import { useAuthStore } from '@/pinia/auth.module';

import PrimaryButton from "@/Components/PrimaryButton.vue";
import StatusSelect from "@/Components/Selects/SelectField.vue";

export default {
  components: {
    PrimaryButton,
    StatusSelect,
  },
  setup() {
    // Crear la instancia del toast aquí
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      status: [
        { id: 23, name: 'Completado' },
        { id: 24, name: 'En proceso' },
        { id: 25, name: 'No aprobado' },
      ],
      selectedFile: null,
      isDisabled: true,
      isDisabledCreate: true
    }
  },
  emits: ['close-modal', 'show-table'],
  props: {
    creditFacility: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(useStatusStore, ['getAllStatusByType']),
    cancelButton() {
      return this.$getLocaleMessage('buttons', 'cancel');
    },
    updateButton() {
      return this.$getLocaleMessage('buttons', 'update');
    },
    statusOptions() {
      return helper.mapOptions(this.status);
    },
    // Datos del prospecto
    prospectFullname() {
      if (this.creditFacility.prospectus?.generalInformation?.businessName) {
        return this.creditFacility.prospectus.generalInformation.businessName;
      } else {
        const info = this.creditFacility.prospectus?.generalInformation || {};
        return `${info.firstName || ''} ${info.lastName || ''} ${info.mothersMaidenName || ''}`.trim();
      }
    },
    prospectAddress() {
      const address = this.creditFacility.prospectus?.generalInformation?.fiscalAddress || {};
      return `${address.street || ''} ${address.exteriorNumber || ''} ${address.interiorNumber || ''} ${address.district || ''}`.trim();
    },
    // Datos de la solicitud
    productTypeName() {
      return this.creditFacility.loanApplication?.quotations?.products?.productTypes?.name || '';
    },
    dateDistribution() {
      //return this.formatDate(this.creditFacility.loanApplication?.quotations?.disbursementDate);
      const originalDate = this.creditFacility.loanApplication?.quotations?.disbursementDate || '';
      return this.$filters?.formattedDateDistribution(originalDate) || '';
    },
    creditAmount() {
      //return this.creditFacility.loanApplication?.quotations?.creditAmount || 0;
      return this.$filters?.formatNumber(this.creditFacility.loanApplication?.quotations?.creditAmount) || '';
    },
    // formattedCreditAmount() {
    //   return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(this.creditAmount);
    // },
    // Datos bancarios
    directDebitNameBank() {
      return this.creditFacility.directDebit?.bank || '';
    },
    directDebitAccountHoldersName() {
      return this.creditFacility.directDebit?.authorizedPersonName || '';
    },
    directDebitBankAccount() {
      return this.creditFacility.directDebit?.accountNumber || '';
    },
    directDebitClabe() {
      return this.creditFacility.directDebit?.clabe || '';
    },
    // Validaciones
    flowStatusAuthorizationOperative() {
      return this.creditFacility.flowStatus?.operational || 0;
    },
    flowStatusAuthorizationLegal() {
      return this.creditFacility.flowStatus?.legal || 0;
    },
    flowStatusAuthorizationAml() {

      if (this.creditFacility?.creditScore?.creditProfiles?.remarks === "No aprobado" || this.creditFacility?.creditScore?.creditProfiles?.name === "Alto") {
        this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'notApproved'));
      }

      return this.creditFacility.flowStatus?.aml || 0;
    },
    // selectedStatusId() {

    //   // Verificar que loanApplication y flowStatus existan
    //   if (!this.creditFacility || !this.creditFacility.flowStatus) {
    //     this.isDisabledCreate = true;
    //     return null; // valor por defecto
    //   }

    //   const { operational, legal, aml } = this.creditFacility.flowStatus;

    //   if (operational === 1 && legal === 1 && aml === 1) {
    //     this.isDisabledCreate = false;
    //     const completado = this.status.find(item => item.name === 'Completado');
    //     return completado ? completado.id : null;
    //   }
    //   else if (aml === 1) {
    //     if (this.creditFacility?.creditScore?.creditProfiles?.name === "Alto" || this.creditFacility?.creditScore?.creditProfiles?.remarks === "No aprobado") {
    //       this.isDisabledCreate = true;
    //       const noAprobado = this.status.find(item => item.name === 'No aprobado');
    //       return noAprobado ? noAprobado.id : null;
    //     }
    //   }
    //   else if (operational === 0 || legal === 0 || aml === 0) {
    //     this.isDisabledCreate = true;
    //     // Encontrar el objeto con name 'En proceso' y retornar su id
    //     const enProceso = this.status.find(item => item.name === 'En proceso');
    //     return enProceso ? enProceso.id : null;
    //   }
    //   else {
    //     isDisabledCreate = true;
    //     return null;
    //   }
    // },

    selectedStatusId() {
      if (!this.creditFacility || !this.creditFacility.flowStatus) {
        this.isDisabledCreate = true;
        return null;
      }

      const { operational, legal, aml } = this.creditFacility.flowStatus;

      // Validar que los valores sean 0 o 1
      const isValidValue = (val) => val === 0 || val === 1;
      if (!isValidValue(operational) || !isValidValue(legal) || !isValidValue(aml)) {
        this.isDisabledCreate = true;
        return null;
      }

      // 1. Condición de "No aprobado" (prioridad máxima cuando aml = 1)
      if (aml === 1) {
        try {
          const creditProfile = this.creditFacility?.creditScore?.creditProfiles;
          if (creditProfile) {
            const isHighRisk = creditProfile.name === "Alto";
            const isNotApproved = creditProfile.remarks === "No aprobado";
            
            if (isHighRisk || isNotApproved) {
              this.isDisabledCreate = true;
              const noAprobado = this.status.find(item => item.name === 'No aprobado');
              return noAprobado ? noAprobado.id : null;
            }
          }
        } catch (error) {
          console.warn('Error al verificar perfil de crédito:', error);
        }
      }

      // 2. Completado (todos en true)
      if (operational === 1 && legal === 1 && aml === 1) {
        this.isDisabledCreate = false;
        const completado = this.status.find(item => item.name === 'Completado');
        return completado ? completado.id : null;
      }

      // 3. Cualquier otra combinación es "En proceso"
      this.isDisabledCreate = true;
      const enProceso = this.status.find(item => item.name === 'En proceso');
      return enProceso ? enProceso.id : null;
    },
    // Archivo actual
    currentFile() {
      return this.creditFacility.receiptPaymentFiles || null;
    }
  },
  methods: {
    ...mapActions(useCreditFacilities, ['updateCreditFacility', 'downloadFile']),
    async downloadCurrentFile() {
      if (!this.currentFile || !this.currentFile.guidName) {
        this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'undefinedFile'));
        return;
      }

      this.downloading = true;
      try {
        // Llamar a la acción del store para descargar el archivo
        await this.downloadFile(this.currentFile.guidName, this.currentFile.name);
      } catch (error) {
        console.error('Error al descargar el archivo:', error);
        // Opcional: mostrar mensaje de error al usuario
        this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'errorDownloadingFile'));
      } finally {
        this.downloading = false;
      }
    },
    async onSubmit() {
      try {
        // Validar que haya un archivo seleccionado si se quiere reemplazar
        if (this.selectedFile) {
          const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
          if (!allowedTypes.includes(this.selectedFile.type)) {
            this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'typeDoc'));
            this.resetFileInput();
            return;
          }

          const maxSize = 5 * 1024 * 1024; // 5MB
          if (this.selectedFile.size > maxSize) {
            this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'sizeFile'));
            this.resetFileInput();
            return;
          }
        }

        //Descomentar si piden estas validaciones si no lo ocupamos se puden eliminar
        /* let findStatus = this.status.find(item => item.id === this.selectedStatusId);

        if (findStatus.name === 'En proceso') {
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'pendingAuthorization'));
          return;
        }

        if (findStatus.name === 'No aprobado') {
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'notApproved'));
          return;
        } */

        // Crear FormData para enviar
        const formData = new FormData();

        // Fechas en formato SQL Server (como en el CURL exitoso)
        const now = new Date();
        const sqlDate = now.toISOString().replace('T', ' ').substring(0, 23);

        formData.append('Id', this.creditFacility.id);
        formData.append('ProspectusId', this.creditFacility.prospectusId);
        formData.append('LoanApplicationId', this.creditFacility.loanApplicationId);
        formData.append('StatusId', this.selectedStatusId);
        formData.append('CompanyId', useAuthStore().user.companyId);
        formData.append('ReferenceNumber', this.creditFacility.referenceNumber);
        formData.append('CreatedAt', this.creditFacility.createdAt || sqlDate);
        formData.append('UpdatedAt', this.creditFacility.updatedAt || sqlDate);

        // Enviar solo el archivo si hay uno nuevo
        if (this.selectedFile) {

          formData.append('ReceiptPaymentFiles.File', this.selectedFile);

          if (this.currentFile) {
            formData.append('ReceiptPaymentFiles.Id', this.currentFile.id);
            formData.append('ReceiptPaymentFiles.CreditFacilitiesId', this.creditFacility.id);
            formData.append('ReceiptPaymentFiles.GuidName', this.currentFile.guidName);
            formData.append('ReceiptPaymentFiles.Name', this.currentFile.name);
            formData.append('ReceiptPaymentFiles.Size', this.currentFile.size);
            formData.append('ReceiptPaymentFiles.FileType', this.currentFile.fileType);
            formData.append('ReceiptPaymentFiles.Version', this.currentFile.version);
            formData.append('ReceiptPaymentFiles.CreatedAt', this.currentFile.createdAt || sqlDate);
            formData.append('ReceiptPaymentFiles.UpdatedAt', sqlDate);

            // Mantener el filePath existente o crear uno nuevo
            if (this.currentFile.filePath) {
              formData.append('ReceiptPaymentFiles.FilePath', this.currentFile.filePath);
            }
          }
        }

        let response = await this.updateCreditFacility(formData);
        if (response && response.status) {
          this.$refs.form.resetForm();
          this.resetFileInput();
          this.closeModal();
        }
      } catch (error) {
        console.error('Error al enviar el formulario:', error);
        this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'errorForm'));
      }
    },
    handleFileChange(event) {
      const fileInput = event.target;

      if (fileInput.files.length > 0) {
        this.selectedFile = fileInput.files[0];
        this.toast.success(`${getLocaleMessage('creditFacilitiesRequest', 'selectFileSuccess')}: ${this.selectedFile.name}`);
      } else {
        this.selectedFile = null;
        console.log('No se seleccionó ningún archivo');
      }
    },
    resetFileInput() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    closeModal() {
      this.$emit('close-modal', true);
    },
    // formatDate(dateString) {
    //   if (!dateString) return '';
    //   const date = new Date(dateString);
    //   return date.toLocaleDateString('es-MX');
    // },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
  },
  mounted() {
    // Inicializar el estado seleccionado con el valor actual
    this.selectedStatusId = this.creditFacility.statusId;
  }
}
</script>

<style scoped>
.current-file {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.file-size {
  font-size: 0.85rem;
  color: #6c757d;
}

.form-text {
  margin-top: 5px;
}
</style>